module.exports = __webpack_public_path__ + "static/media/logo.231bf14e.png";